import { ColumnsType } from "antd/es/table";
import { DataType } from "./Interface";
import { Text } from "@shopify/polaris";
import React from "react";
import { useTranslation } from "react-i18next";

export const modalGridColumns = [
    {
        title: 'Item Name',
        dataIndex: 'item_name',

    },
    {
        title: 'Refund Inventory',
        dataIndex: 'inventory',
        width: '20%'
    },
    {
        title: 'Refund Reason (Amazon)',
        dataIndex: 'refund_reason',
    },
    {
        title: 'Total Item Price',
        dataIndex: 'total_item_price',
    },
    {
        title: 'Refund Amount',
        dataIndex: 'refund_amount',
    }
];

export function allOrdersColumns() {
    const { t } = useTranslation();
    let cols: ColumnsType<DataType> = [
        {
            title: <Text as="p" fontWeight="bold">
                {t("Order ID")}
            </Text>,
            dataIndex: 'id',
            key: 1,
            width: '230px',
        },
        {
            title: <Text as="p" fontWeight="bold">
                {t("Status")}
            </Text>,
            dataIndex: 'status',
            key: 2,
            width: '150px',
        },
        {
            title: <Text as="p" fontWeight="bold">
                {t("Sync Status")}
            </Text>,
            dataIndex: 'sync_status',
            key: 3,
            width: '200px',
        },
        {
            title: <Text as="p" fontWeight="bold">
                {t("Ordered Items")}
            </Text>,
            dataIndex: 'ordered_items',
            key: 4,
            width: '120px',
        },
        {
            title: <Text as="p" fontWeight="bold">
                {t("Total Price")}
            </Text>,
            dataIndex: 'total_price',
            key: 5,
            width: '100px',
        },
        {
            title: <Text as="p" fontWeight="bold">
                {t("Created on Amazon")}
            </Text>,
            dataIndex: 'created_at',
            key: 6,
            width: '200px',
            sorter: ((a: any, b: any): any => {
                let bdate: any = new Date(b.date);
                let adate: any = new Date(a.date);
                return adate - bdate;
            }),
            sortDirections: ['ascend']
        },
        {
            title: <Text as="p" fontWeight="bold">
                {t("Tags")}
            </Text>,
            dataIndex: 'tags',
            key: 7,
            width: '150px',
        },
        {
            title: <Text as="p" fontWeight="bold">
                {t("Actions")}
            </Text>,
            dataIndex: 'actions',
            key: 8,
            width: '130px',
        },
    ];
    return { allOrderCols: cols };
}

export const ordersFilter = {
    'Status': {
        value: 'status',
        textValue: '',
        platform: '',
        selectValue: '3',
        label: '',
        label2: '',
        change: false,
    },
    "Sync Status": {
        value: '',
        textValue: '',
        selectValue: '1',
        label: '',
        change: false,
    },
    "Price": {
        value: 'total.price',
        textValue: '',
        selectValue: '1',
        change: false,
    },
    "Order Date": {
        value: 'source_created_at',
        start: "",
        end: "",
        textValue: "",
        selectValue: '1',
        change: false
    },
    'Tags': {
        value: 'fulfilled_by' || 'is_ispu',
        textValue: '',
        selectValue: '1',
        label: "",
        change: false,
    },
    "Orders": {
        from: '',
        to: '',
        textValue: '',
        selectValue: '1',
        change: false,
    }
}

export const optionsSelect = () => {
    const { t } = useTranslation();
    let opt = [
        { label: t('Equals'), value: '1' },
        { label: t('Not Equals'), value: '2' },
        { label: t('Contains'), value: '3' },
        { label: t('Does not Contains'), value: '4' },
        { label: t('Starts With'), value: '5' },
        { label: t('Ends With'), value: '6' },
        { label: t('Greater Than or Equal to'), value: '8' },
        { label: t('Less Than or Equal to'), value: '9' },
    ];
    return { selectOption: opt }
}

export const optionsForTags = [
    { label: 'FBM', value: 'FBM' },
    { label: 'FBA', value: 'FBA' },
]

export function statusPlatformOpt() {
    const { t } = useTranslation();
    let opt = [
        { label: t('Amazon'), value: 'marketplace_status' },
        { label: t('Shopify'), value: 'targets.status' }
    ]
    return { statusPlatformOption: opt };
}

export function amazonStatusOpt() {
    const { t } = useTranslation();
    let opt = [
        { label: t('Unshipped'), value: 'Unshipped' },
        { label: t('Shipped'), value: 'Shipped' },
        { label: t('Cancelled'), value: 'Cancelled' },
        { label: t('Return'), value: 'Failed' },
    ]
    return { amazonStatusOption: opt }
}

export const shopifyStatusOpt = () => {
    const { t } = useTranslation();
    let opt = [
        { label: t('Partially Fulfilled'), value: 'Partially Shipped' },
        { label: t('Unfulfilled'), value: 'Created' },
        { label: t('Fulfilled'), value: 'Shipped' },
        { label: t('Cancelled'), value: 'Cancelled' }
    ]
    return { shopifyStatusOption: opt }
}

export const syncStatusOpt = () => {
    let { t } = useTranslation();
    let opt = [
        { label: t('Failed Order'), key: 'failed', value: 'failed_order' },
        { label: t('Failed Refund'), key: 'Failed', value: "failed_refund" },
        { label: t('Failed Shipment'), key: 'true', value: 'failed_shipment' },
        { label: t('Failed Cancellation'), key: 'Failed', value: 'failed_cancellation' },
        { label: t('Created'), key: 'Created', value: 'created' },
        { label: t('Cancelled'), key: 'Cancelled', value: 'cancelled' },
        { label: t('Refunded'), value: 'Refunded', key: 'refund' },
    ];
    return { syncStatusOption: opt }
}

export function priceSelectOpt() {
    let { t } = useTranslation();
    let opt = [
        { label: t('Equals'), value: '1' },
        { label: t('Not Equals'), value: '2' },
        { label: t('Greater Than or Equal to'), value: '8' },
        { label: t('Less Than or Equal to'), value: '9' },
    ];
    return { priceSelectOption: opt }
}

export const shopifyReasons = () => {
    const { t } = useTranslation();
    let opt = [
        { label: t("Please Select"), value: "", disabled: true },
        { label: t("Customer"), value: "customer" },
        { label: t("Inventory"), value: "inventory" },
        { label: t("Fraud"), value: "fraud" },
        { label: t("Declined"), value: "declined" },
        { label: t("Other"), value: "other" },
    ]
    return { shopifyReasonOpt: opt }
};

export const cancellationModalGridColumns = () => {
    const { t } = useTranslation();
    let opt = [
        {
            title: t('Product Name'),
            dataIndex: 'item_name',

        },
        {
            title: t('Inventory'),
            dataIndex: 'inventory',

        },
        {
            title: t('Cancelation Reason (Amazon)'),
            dataIndex: 'cancellation_reason',
        },
        {
            title: t('Total Item Price'),
            dataIndex: 'total_item_price',
        }
    ];
    return { cancellationModalOpt: opt }
}

export const amazonReasons = () => {
    const { t } = useTranslation();
    const opt = [
        { label: t("Select Reason"), value: "", disabled: true },
        { label: t("No Inventory"), value: "NoInventory" },
        { label: t("Customer Return"), value: "CustomerReturn" },
        { label: t("General Adjustment"), value: "GeneralAdjustment" },
        { label: t("Could Not Ship"), value: "CouldNotShip" },
        { label: t("Different Item"), value: "DifferentItem" },
        { label: t("Abandoned"), value: "Abandoned" },
        { label: t("Customer Cancel"), value: "CustomerCancel" },
        { label: t("Price Error"), value: "PriceError" },
        { label: t("Product Out of Stock"), value: "ProductOutofStock" },
        { label: t("Customer Address Incorrect"), value: "CustomerAddressIncorrect" },
        { label: t("Exchange"), value: "Exchange" },
        { label: t("Carrier Credit Decision"), value: "CarrierCreditDecision" },
        { label: t("Risk Assessment Information Not Valid"), value: "RiskAssessmentInformationNotValid" },
        { label: t("Carrier Coverage Failure"), value: "CarrierCoverageFailure" },
        { label: t("Transaction Record"), value: "TransactionRecord" },
        { label: t("Undeliverable"), value: "Undeliverable" },
        { label: t("Refused Delivery"), value: "RefusedDelivery" },
        { label: t("Other"), value: "Other" },
    ];
    return { amazonReasonsOpt: opt }
}

export const refundModalGridColumns = () => {
    const { t } = useTranslation();
    const cols = [
        {
            title: t('Item Name'),
            dataIndex: 'item_name',

        },
        {
            title: t('Refund Inventory'),
            dataIndex: 'inventory',
            width: '20%'
        },
        {
            title: t('Refund Reason (Amazon)'),
            dataIndex: 'refund_reason',
        },
        {
            title: t('Total Item Price'),
            dataIndex: 'total_item_price',
        },
        {
            title: t('Refund Amount'),
            dataIndex: 'refund_amount',
        }
    ];
    return { refundModalGridCols: cols }
}

export const viewOrderColumns = (t: any): ColumnsType<DataType> => [
    {
        title: <Text variant="bodySm" as="span" fontWeight="medium" tone='subdued'>{t("Title")}</Text>,
        dataIndex: 'title',
        key: 'title',
        width: '200px',
    },
    {
        title: <Text variant="bodySm" as="span" fontWeight="medium" tone='subdued'>{t("Product Details")}</Text>,
        dataIndex: 'product',
        key: 'product',
        width: '150px',
    },
    {
        title: <Text variant="bodySm" as="span" fontWeight="medium" tone='subdued'>{t("Inventory")}</Text>,
        key: 'quantity',
        dataIndex: 'quantity',
        width: '100px',
    },
    {
        title: <Text variant="bodySm" as="span" fontWeight="medium" tone='subdued'>{t("Price (VAT exclusive)")}</Text>,
        key: 'price',
        dataIndex: 'price',
        width: '100px',
    },
    {
        title: <Text variant="bodySm" as="span" fontWeight="medium" tone='subdued'>{t("Price (VAT inclusive)")}</Text>,
        key: 'vat',
        dataIndex: 'vat',
        width: '100px',
    },
];
